import { httpAuthAxios } from "./request";

export const getClearText = (data) => {
  return httpAuthAxios({
    url: "/v1/baseRpc/getUserInfo",
    method: "post",
    data,
  });
};
